import "./WorkflowModal.css";

import { Formik, Form, Field } from "formik";
import { useEffect } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";

import { Case, User } from "pwapi";

import { patchCaseWorkflow } from "shared/actions/caseDetailActions";
import { listUsers } from "shared/actions/listUsersActions";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import ApplicationState from "store/ApplicationState";

type WorkflowModalProps = {
  isOpen: boolean;
  caseDetailObject: CaseDetailState;
  setWorkflowModal: Function;
};

const WorkflowModal = ({
  isOpen,
  caseDetailObject,
  setWorkflowModal,
}: WorkflowModalProps) => {
  const dispatch = useDispatch();
  const users: User[] = useSelector(
    ({ usersList }: ApplicationState) => usersList
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(
        listUsers({
          limit: 9999,
          userprofileUserType: ["dermpath"],
          ordering: "last_name,first_name",
        })
      );
    }
  }, [isOpen, dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setWorkflowModal(false)}
      contentLabel="Case Workflow"
      className="Modal"
      overlayClassName="Overlay"
    >
      <div className="CaseWorkflowModal">
        <Formik
          initialValues={{
            active_assignment_id: caseDetailObject.active_assignment?.id,
            status: caseDetailObject.status,
          }}
          onSubmit={(values) => {
            dispatch(
              patchCaseWorkflow({
                case_id: caseDetailObject.id,
                ...values,
              })
            );
            setWorkflowModal(false);
          }}
        >
          <Form>
            <h4>Case Assignment</h4>
            <div className="CaseWorkflowModal__fields">
              {caseDetailObject.source !== Case.source.PW && (
                <label>
                  Active Assignment
                  <br />
                  <Field as="select" name="active_assignment_id">
                    <option value="" disabled></option>
                    {users.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.last_name}, {u.first_name}
                      </option>
                    ))}
                  </Field>
                </label>
              )}
              <label>
                Status
                <br />
                <Field as="select" name="status">
                  <option value="" disabled></option>
                  {["active", "working", "finalized"].map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </Field>
              </label>
            </div>
            <div className="CaseWorkflowModal__buttons">
              <button
                className="btn btn-link"
                onClick={() => setWorkflowModal(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
};

export default WorkflowModal;
